"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVMAccount = void 0;
const ethers_1 = require("ethers");
const chain_1 = require("../../chain");
const utils_1 = require("../../utils");
const operation_1 = require("../operation");
const transaction_1 = require("../transaction");
const account_1 = require("./account");
const balance_1 = require("./balance");
class EVMAccount extends account_1.AbstractChainAccount {
    chain;
    chainWallet;
    provider;
    constructor(provider, chainId, wallet) {
        super(account_1.AccountType.Nonce, provider.jevmApi[chainId].chain, wallet);
        this.chain = provider.jevmApi[chainId].chain;
        this.chainWallet = wallet.getJEVMWallet(this.chain);
        this.provider = provider;
    }
    async estimate(operation) {
        const provider = await this.provider.getStaticProvider();
        if (operation.type === operation_1.NetworkOperationType.Send) {
            const send = operation;
            const isContract = (0, utils_1.isContractAddress)(send.assetId);
            const address = isContract ? send.assetId : send.address;
            const data = isContract
                ? await this.chain.getContractTransactionData(provider, send.assetId, address, send.amount)
                : chain_1.EmptyCallData;
            return await (0, transaction_1.estimateEVMOperation)(provider, this.chain, this.chainWallet.getAddress(), send, [new transaction_1.BaseSpending(this.chain, send.amount, send.assetId)], new Map([[send.assetId, send.amount]]), address, isContract ? BigInt(0) : send.amount, data, transaction_1.TransactionType.Base);
        }
        else if (operation.type === operation_1.NetworkOperationType.Wrap) {
            const wrap = operation;
            return await (0, transaction_1.estimateEVMOperation)(provider, this.chain, this.chainWallet.getAddress(), wrap, [new transaction_1.BaseSpending(this.chain, wrap.amount, this.chain.assetId)], new Map([[this.chain.assetId, wrap.amount]]), wrap.asset.address, wrap.amount, wrap.asset.adapter.getDepositData(), transaction_1.TransactionType.Wrap);
        }
        else if (operation.type === operation_1.NetworkOperationType.Unwrap) {
            const unwrap = operation;
            return await (0, transaction_1.estimateEVMOperation)(provider, this.chain, this.chainWallet.getAddress(), unwrap, [new transaction_1.BaseSpending(this.chain, unwrap.amount, unwrap.asset.assetId)], new Map([[unwrap.asset.assetId, unwrap.amount]]), unwrap.asset.address, BigInt(0), unwrap.asset.adapter.getWithdrawData(unwrap.amount), transaction_1.TransactionType.Unwrap);
        }
        else if (operation.type === operation_1.NetworkOperationType.EthCall) {
            const ethCall = operation;
            const contract = new ethers_1.ethers.Contract(ethCall.contract, ethCall.abi, this.chain.ethProvider);
            const data = contract.interface.encodeFunctionData(ethCall.functionName, ethCall.values);
            const values = new Map();
            if (ethCall.amount > 0) {
                values.set(this.chain.assetId, ethCall.amount);
            }
            return await (0, transaction_1.estimateEVMOperation)(provider, this.chain, this.chainWallet.getAddress(), ethCall, [], values, ethCall.contract, ethCall.amount, data, transaction_1.TransactionType.EthCall);
        }
        throw new utils_1.AccountError(`unsupported operation: ${operation.type} for the chain with id: ${this.chain.id}`);
    }
    async execute(summary) {
        super.spend(summary.spendings);
        const operation = summary.operation.type;
        if (operation === operation_1.NetworkOperationType.Send) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.Send);
        }
        else if (operation === operation_1.NetworkOperationType.Wrap) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.Wrap);
        }
        else if (operation === operation_1.NetworkOperationType.Unwrap) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.Unwrap);
        }
        else if (operation === operation_1.NetworkOperationType.EthCall) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.EthCall);
        }
        // could be replaced with correct spend and fund but just sync all now for simplicity
        // if replaced it should take some extra cases into account e.g. sending to self
        await this.fetchBalances(summary.getAssets().values());
    }
    async executeAndTrackTransaction(summary, type) {
        const executable = summary.getExecutable();
        const transactionHash = await (0, transaction_1.executeEVMTransaction)(executable.provider, this.chainWallet, summary.fee);
        await executable.trackEVMTransaction(this.chain.id, transactionHash, type);
    }
    async fetchBalance(assetId) {
        if (!this.balances.has(assetId)) {
            this.balances.set(assetId, new balance_1.Balance());
        }
        const balance = this.balances.get(assetId);
        const address = this.chainWallet.getAddress();
        await balance.updateAsync(this.chain.queryBalance(this.provider.jevmApi[this.chain.id], address, assetId));
    }
}
exports.EVMAccount = EVMAccount;
